<template>
    <v-container
        fluid
        grid-list-lg
        fill-height
    >
        <v-layout row>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :items="contacts"
                    class="elevation-1"
                    :search="search"
                    sort-by="name"
                    hide-default-footer
                    :items-per-page="contacts.length + 1"
                >
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Suchen/Filtern"
                                single-line
                                clearable
                                hide-details
                            />
                            <v-spacer/>
                            <v-dialog
                                v-model="dialog"
                                max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        class="mb-2 text--secondary"
                                        v-on="on">
                                        Neuer Kontakt
                                    </v-btn>
                                </template>
                                <v-card
                                    :loading="dialogLoading"
                                    :disabled="dialogLoading">
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.name"
                                                        label="Name">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.position"
                                                        label="Position">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-combobox
                                                        v-model="editedItem.surName"
                                                        :items="companies"
                                                        hide-selected
                                                        label="Firma"
                                                        persistent-hint
                                                    />
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.mobileNumber"
                                                        label="Mobile-Nummer">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.email"
                                                        label="Email-Adresse">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn
                                            class="text--secondary"
                                            text
                                            @click="close">
                                            Abbrechen
                                        </v-btn>
                                        <v-btn
                                            class="text--secondary"
                                            text
                                            @click="save">
                                            Speichern
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.mobileNumber="{ item }">
                        <span v-if="item.mobileNumber !== '00'">{{ item.mobileNumber }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    @click="editItem(item)"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>Ändern</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    @click="deleteItem(item)"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>Löschen</span>
                        </v-tooltip>

                        <v-icon
                            v-if="false"
                            class="mr-3"
                        >
                            mdi-account-switch
                        </v-icon>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    @click="openContactBuildingList(item)"
                                >
                                    mdi-domain
                                </v-icon>
                            </template>
                            <span>Projekte anzeigen</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <simple-building-list ref="contactBuildings" hidden/>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    components: {
        SimpleBuildingList: () => import('./SimpleBuildingList'),
    },
    data: () => ({
        dialog: false,
        dialogLoading: false,
        search: '',
        headers: [
            {text: 'Name', value: 'name'},
            {text: 'Firma', value: 'surName'},
            {text: 'Position', value: 'position'},
            {text: 'Email-Adresse', value: 'email'},
            {text: 'Mobile-Nummer', value: 'mobileNumber'},
            {text: '', value: 'action', sortable: false, align: 'end', filterable: false}
        ],
        contacts: [],
        editedIndex: -1,
        editedItem: {
            uuid: '',
            name: '',
            email: '',
            mobileNumber: '00'
        },
        defaultItem: {
            uuid: '',
            name: '',
            email: '',
            mobileNumber: '00'
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Kontakt anlegen' : 'Kontakt ändern'
        },
        companies() {
            let comp = [];
            this.contacts.forEach((c) => {
                if (c.surName !== '' && c.surName !== null) {
                    comp.push(c.surName)
                }
            });
            return [...new Set(comp)]
        }
    },
    watch: {
        dialog(val) {
            val || this.close()
        },
    },
    created() {
        axios.get('/address-contact/api/contact/')
            .then(response => {
                this.contacts = response.data
            })
    },
    beforeDestroy() {
        this.$store.dispatch('loadContacts')
    },
    methods: {
        editItem(item) {
            this.editedIndex = this.contacts.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true
        },
        deleteItem(item) {
            const index = this.contacts.indexOf(item);
            this.deleteItemNotifications(item);
            axios.delete('/address-contact/api/contact/' + item.uuid + '/')
                .then(() => {
                    this.contacts.splice(index, 1)
                })
        },
        deleteItemNotifications(item) {
            axios.delete('/notification/api/notification/?contact=' + item.uuid)
        },
        close() {
            this.dialog = false;
            this.dialogLoading = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            }, 300)
        },
        save() {
            this.dialogLoading = true;
            if (this.editedItem.mobileNumber == null || this.editedItem.mobileNumber.trim().length === 0)
                this.editedItem.mobileNumber = '00';
            if (this.editedIndex > -1) {
                axios.put('/address-contact/api/contact/' + this.editedItem.uuid + '/', this.editedItem)
                    .then((response) => {
                        Object.assign(this.contacts[this.editedIndex], response.data);
                        this.close()
                    })
            } else {
                axios.post('/address-contact/api/contact/', this.editedItem)
                    .then((response) => {
                        this.contacts.push(response.data);
                        this.close()
                    })
            }
        },
        openContactBuildingList(contact) {
            this.$refs.contactBuildings.init(contact)
        }
    },
}
</script>
